export enum HASHTAG_LIMITS_ACTIONS {
  OPEN_HASHTAG_LIMITS_MODAL = 'HASHTAG_LIMITS/OPEN_HASHTAG_LIMITS_MODAL',
  CLOSE_HASHTAG_LIMITS_MODAL = 'HASHTAG_LIMITS/CLOSE_HASHTAG_LIMITS_MODAL',

  SET_NEW_HASHTAG_NAME = 'HASHTAG_LIMITS/SET_NEW_HASHTAG_NAME',

  REQUEST_HASHTAGS_USAGE = 'HASHTAG_LIMITS/REQUEST_HASHTAGS_USAGE',
  RECEIVE_HASHTAGS_USAGE_SUCCEEDED = 'HASHTAG_LIMITS/RECEIVE_HASHTAGS_USAGE_SUCCEEDED',
  RECEIVE_HASHTAGS_USAGE_FAILED = 'HASHTAG_LIMITS/RECEIVE_HASHTAGS_USAGE_FAILED',

  REQUEST_TRACK_NEW_HASHTAG = 'HASHTAG_LIMITS/TRACK_NEW_HASHTAG',
  RECEIVE_TRACK_NEW_HASHTAG_SUCCEEDED = 'HASHTAG_LIMITS/RECEIVE_TRACK_NEW_HASHTAG_SUCCEEDED',
  RECEIVE_TRACK_NEW_HASHTAG_FAILED = 'HASHTAG_LIMITS/RECEIVE_TRACK_NEW_HASHTAG_FAILED',

  REQUEST_UNTRACK_HASHTAG = 'HASHTAG_LIMITS/REQUEST_UNTRACK_HASHTAG',
  RECEIVE_UNTRACK_HASHTAG_SUCCEEDED = 'HASHTAG_LIMITS/RECEIVE_UNTRACK_HASHTAG_SUCCEEDED',
  RECEIVE_UNTRACK_HASHTAG_FAILED = 'HASHTAG_LIMITS/RECEIVE_UNTRACK_HASHTAG_FAILED',
}

export const MANAGE_TRACKED_SOURCES_PERMISSION =
  'measure:manage_tracked_source';
